module.exports = __webpack_public_path__ + "img/courses-3.2cfcd927.jpg";